<template>
  <page-outline :title="$t('common.security.title')">
    <template slot="pageContent">
      <div class="listPage ml-3 mr-3">
        <b-row class="justify-content-start">
          <b-col cols="4" lg="2" xl="2" class="mb-5">
            <b-button class="btnFilter" :disabled="activateSpinner"
              @click="onRefresh()">
              <i class="fa-light fa-rotate-right fs-14px"></i>
              {{ $t('common.rfrsh') }}
            </b-button>
          </b-col>
          <b-col cols="9" lg="8" xl="6" class="text-xl-center mb-5">
            <b-button-group class="mt-3 mt-sm-0">
              <b-button :variant="tabName === 0 ? 'primary btn-selected' : ''" @click="tabName = 0">{{ $t('common.security.trust_store') }}</b-button>
              <b-button :variant="tabName === 1 ? 'primary btn-selected' : ''" @click="tabName = 1">{{ $t('common.security.key_store') }}</b-button>
            </b-button-group>
          </b-col>
        </b-row>
        <b-row class="justify-content-start">
          <b-col cols="6" lg="4" xl="4" class="mb-5">
            <b-button variant="secondary"
              @click="addP12"
              :disabled="!canAdd">
              <i class="fa-light fa-plus"></i>
              <span v-if="tabName === 0">{{$t('common.security.add_p12', {itemLabel: 'truststore'})}}</span>
              <span v-else-if="tabName === 1">{{$t('common.security.add_p12', {itemLabel: 'keystore'})}}</span>
            </b-button>
          </b-col>
          <b-col cols="6" lg="4" xl="4" class="mb-5">
            <b-button variant="secondary"
              @click="addPEM"
              :disabled="!canAdd">
              <i class="fa-light fa-plus"></i>
              <span v-if="tabName === 0">{{$t('common.security.add_pem', {itemLabel: 'truststore'})}}</span>
              <span v-else-if="tabName === 1">{{$t('common.security.add_pem', {itemLabel: 'keystore'})}}</span>
            </b-button>
          </b-col>
        </b-row>
        <b-tabs v-model="tabName" nav-class="d-none">
<!--          <b-tab :title="$t('common.security.configurations')">-->
<!--            <security-list typeList="configuration" :key="refreshKey" :spinnerActivated="activateSpinner" v-model="tabValue"></security-list>-->
<!--          </b-tab>-->
          <b-tab :title="$t('common.security.ca')" v-if="canSeeCA">
            <security-list typeList="ca" :key="refreshKey" :spinnerActivated="activateSpinner" v-model="tabValue"></security-list>
          </b-tab>
          <b-tab :title="$t('common.security.keystore')" v-if="canSeeKeyStore">
            <security-list typeList="keystore" :key="refreshKey" :spinnerActivated="activateSpinner" v-model="tabValue"></security-list>
          </b-tab>
<!--          <b-tab :title="$t('common.security.certificates')" v-if="canSeeCertificates">-->
<!--            <security-list typeList="certificate" :key="refreshKey" :spinnerActivated="activateSpinner" v-model="tabValue"></security-list>-->
<!--          </b-tab>-->
<!--          <b-tab :title="$t('common.security.priv_ks')" v-if="canSeePrivateKeys">-->
<!--            <security-list typeList="privatekey" :key="refreshKey" :spinnerActivated="activateSpinner" v-model="tabValue"></security-list>-->
<!--          </b-tab>-->
        </b-tabs>
      </div>
    </template>
  </page-outline>
</template>

<script>
import SecurityList from '@/pages/security/SecurityList.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import {loadPage} from "@/helpers/routing";

export default {
  name: 'SecurityPage',
  components: {
    'page-outline': PageOutline,
    'security-list': SecurityList
  },
  props: {
    role: {
      type: String,
      default: '0'
    }
  },
  computed: {
    canSeeCA () {
      return this.$engine.rights.rightIs('ca_consult', true)
    },
    canSeeKeyStore () {
      let state = this.$engine.rights.rightIs('certificate_consult', true) && this.$engine.rights.rightIs('privatekey_consult', true)
      return state
    },
    canSeeCertificates () {
      return this.$engine.rights.rightIs('certificate_consult', true)
    },
    canSeePrivateKeys () {
      return this.$engine.rights.rightIs('privatekey_consult', true)
    }
  },
  watch: {
    tabName (val) {
      this.$engine.security.currentTab = val
    }
  },
  data () {
    return {
      activateSpinner: false,
      refreshState: false,
      refreshKey: false,
      tabName: 0,
      tabValue: 0,
      canAdd: false
    }
  },
  created () {
    this.tabName = this.role === '1' ? 1 : 0
    // if (this.id !== '-1') {
    //   this.tabName = parseInt(this.id)
    // }
    this.canAdd = true
  },
  methods: {
    onRefresh () {
      this.refreshKey = !this.refreshKey
    },
    addP12 () {
      let that = this
      loadPage(that, {url: '/security/form/' + this.tabName})
    },
    addPEM () {
      let that = this
      loadPage(that, {url: '/security/form/pem/' + this.tabName})
    }
  }
}
</script>
